import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { HeaderWrapper, CentralWrapper, CentralInternalWrapper, TeamName, TeamNameH1 } from './styles';
import TeamBigLogo from '../shared/TeamBigLogo';
import Label from '../shared/Label';
import ConfigManager from '../../common/configManager/configManager';
import IconFont from '../../components/shared/IconFont';
// Import MyGazzettaFollow from '../../components/MyGazzettaFollow';

class TeamHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { headerInfo, dictionary, isMobile } = this.props;
    const teamsImageUrl = ConfigManager.getFootballTeams('high');
    const isGazzetta = () => process.env.REACT_APP_SITE === 'gazzetta';
    //const isSerieA = () => (Number(headerInfo.competitionId)) === 21;
    const isNewsTab = () => window.section_lev3 && window.section_lev3 === 'notizie';
    const mapTeamName = (teamName) => {
      switch (teamName) {
        case 'Internazionale':
          return 'Inter';
        case 'Napoli':
          return 'Napoli Calcio';
        case 'Roma':
          return 'AS Roma';
        case 'Los Angeles Football Club':
          return 'Los Angeles FC';
        default:
          return teamName;
      }
    };
    return (
      <Row>
        <span
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            margin: '10px 0px 0px 15px',
          }}
        >
          <IconFont
            className="icon-matchcenter-back-arrow"
            color="black"
            font={26}
            onClick={() => window.history.back(-1)}
            withCursor
            marginLeft={isMobile ? 0.3 : 0}
          />
        </span>
        <Col lg={12} md={12} sm={12} style={{ overflow: 'visible' }}>
          {headerInfo && headerInfo.teamName &&
            <HeaderWrapper className={`${mapTeamName(headerInfo.teamName).toLowerCase()}`}>
              <TeamBigLogo image={`${teamsImageUrl}${headerInfo.teamId}.png`} />
              <Col
                lg={6}
                md={8}
                sm={12}
                xs={12}
                offset={{
                  lg: 3, md: 2, sm: 0, xs: 0,
                }}
                style={{ justifyContent: 'center', display: 'flex' }}
              >
                <CentralWrapper>
                  {isNewsTab() && isGazzetta() ?
                    <TeamNameH1 isMobile={isMobile}>
                      {mapTeamName(headerInfo.teamName)}
                    </TeamNameH1> :
                    <TeamName isMobile={isMobile}>
                      {mapTeamName(headerInfo.teamName)}
                    </TeamName>
                  }
                  {
                  headerInfo && Number(headerInfo.competitionId) !== 4 && Number(headerInfo.competitionId) !== 88 &&
                  <CentralInternalWrapper>
                    <Label
                      label={`${dictionary[headerInfo.competitionId]} ${(headerInfo.competitionId === '3' || headerInfo.competitionId === '1277') ? '' : headerInfo.formatSeason}`}
                      size={isMobile ? 1 : 1.1}
                      color="white"
                      isTitleNarrowMedium
                      uppercase
                    />
                      {!isMobile &&
                        <Label
                          label="|"
                          size={isMobile ? 0.85 : 1.1}
                          color="white"
                          isTitleNarrowRegular
                          margin={isMobile ? '0em 0 0' : '0em 0 0 0.2em'}
                        />
                      }
                    <Label
                      label={`${dictionary.standings}${headerInfo.rankingPosition}`}
                      size={isMobile ? 0.85 : 1.1}
                      color="white"
                      isTitleNarrowRegular
                      margin={isMobile ? '0em 0 0' : '0em 0 0 0.2em'}
                    />
                  </CentralInternalWrapper>
                  }
                </CentralWrapper>
              </Col>
              <Col lg={3} md={2} sm={2} xs={2} />
            </HeaderWrapper>
          }
        </Col>
      </Row>
    );
  }
}

TeamHeader.propTypes = {
  headerInfo: PropTypes.any,
  dictionary: PropTypes.any,
  isMobile: PropTypes.bool,
};

export default TeamHeader;



// WEBPACK FOOTER //
// ./src/lib/components/TeamHeader/index.js